import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, Card, Stack, Typography } from '@mui/material';

export default function BenefitsEmptyLivePreview() {
  return (
    <Card
      sx={{
        display: 'grid',
        placeItems: 'center',
        p: { xs: 3, md: 5 },
        borderRadius: 2,
        boxShadow: 3,
        border: '2px dashed',
        borderColor: 'grey.400',
        width: '100%',
        maxWidth: 460,
        minWidth: 0,
        mx: 'auto',
        transform: { lg: 'translateX(-8px)', xl: 'translateX(-14px)' },
        position: 'relative',
        background: 'linear-gradient(160deg, #f3f4f6 0%, #e8ebee 100%)',
        overflow: 'hidden',
        maxHeight: 'calc(100vh - 96px)',
        overflowY: 'auto',
        overflowX: 'hidden',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          width: 0,
          height: 0,
          display: 'none',
        },
        minHeight: 280,
        // '&::before': {
        //   content: '""',
        //   position: 'absolute',
        //   top: '50%',
        //   left: '-14px',
        //   transform: 'translateY(-50%)',
        //   width: '28px',
        //   height: '28px',
        //   borderRadius: '50%',
        //   backgroundColor: '#d9dde2',
        // },
        // '&::after': {
        //   content: '""',
        //   position: 'absolute',
        //   top: '50%',
        //   right: '-14px',
        //   transform: 'translateY(-50%)',
        //   width: '28px',
        //   height: '28px',
        //   borderRadius: '50%',
        //   backgroundColor: '#d9dde2',
        // },
      }}
    >
      <Stack spacing={2} alignItems="center" sx={{ textAlign: 'center', maxWidth: 320 }}>
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            bgcolor: 'grey.200',
            display: 'grid',
            placeItems: 'center',
            color: 'grey.700',
          }}
        >
          <VisibilityOutlinedIcon />
        </Box>

        <Typography variant="h6" sx={{ color: 'grey.800', fontWeight: 700 }}>
          Live Preview indisponível neste ambiente
        </Typography>

        <Typography variant="body2" sx={{ color: 'grey.700' }}>
          O Live Preview aparece apenas para o ambiente VIVA CENTER NORTE. Selecione{' '}
          <b>VIVA CENTER NORTE</b> para visualizar a prévia em tempo real aqui.
        </Typography>
      </Stack>
    </Card>
  );
}
